import API from "../api";
import { apiCallbackTreatment } from "../auxiliary/generalFunctions";

const api = new API();

export default class WhatsAppController
{
    async getAllChats(amount, searching, idUserCRM, idUserCRMOnAccess, toViewAll, myOwnCalleds, isClosedCalleds) 
    {
        const response = await api.whatsapp().getAllChats(amount, searching, idUserCRM, idUserCRMOnAccess, toViewAll, myOwnCalleds, isClosedCalleds);
        return apiCallbackTreatment(response);
    }

    async send({idContact, message, phone, idUserCRM, nameUserCRM, idDepartament, idCalled, idUserCRMFromCalled, idDepartamentFromUserWithMultipleDepartaments, isCommentSending, idServiceDigiSac, idMessageReference = null, file = null}) 
    {
        const response = await api.whatsapp().send(idContact, message, phone, idUserCRM, nameUserCRM, idDepartament, idCalled, idUserCRMFromCalled, idDepartamentFromUserWithMultipleDepartaments, isCommentSending, idServiceDigiSac, idMessageReference, file);
        return apiCallbackTreatment(response);
    }

    async sendImage(formData) 
    {
        const response = await api.whatsapp().sendImage(formData);
        return apiCallbackTreatment(response);
    }

    async sendDocument(formData) 
    {
        const response = await api.whatsapp().sendDocument(formData);
        return apiCallbackTreatment(response);
    }

    async sendAudio(formData) 
    {
        const response = await api.whatsapp().sendAudio(formData);
        return apiCallbackTreatment(response);
    }
    
    async deleteMessage(id, idDepartament) 
    {
        const response = await api.whatsapp().deleteMessage(id, idDepartament);
        return apiCallbackTreatment(response);
    }

    async getAmountScreenshotToAnswerMessage(id)
    {
        const response = await api.whatsapp().getAmountScreenshotToAnswerMessage(id);
        return apiCallbackTreatment(response);
    }

    async getTokenFirebase()
    {
        const response = await api.whatsapp().getTokenFirebase();
        return apiCallbackTreatment(response);
    }

    async reTryingDownloadFile (id, idDepartament)
    {
        const response = await api.whatsapp().reTryingDownloadFile(id, idDepartament);
        return apiCallbackTreatment(response);
    }

    async setAudioDuration (idMessageDigiSac, duration)
    {
        const response = await api.whatsapp().setAudioDuration(idMessageDigiSac, duration);
        return apiCallbackTreatment(response);
    }

    async closeCalled({idCalled}) 
    {
        const response = await api.whatsapp().closeCalled(idCalled);
        return apiCallbackTreatment(response);
    }

    async updateNotReadCalledsAndMessages(idUserCRMFromCalled, idCalled) 
    {
        const response = await api.whatsapp().updateNotReadCalledsAndMessages(idUserCRMFromCalled, idCalled);
        return apiCallbackTreatment(response);
    }

    async getAllDepartaments(idServiceDigiSac) 
    {
        const response = await api.whatsapp().getAllDepartaments(idServiceDigiSac);
        return apiCallbackTreatment(response);
    }

    async getAllUsersFromDepartaments()
    {
        const response = await api.whatsapp().getAllUsersFromDepartaments();
        return apiCallbackTreatment(response);
    }

    async getUsersByDepartament(id)
    {
        const response = await api.whatsapp().getUsersByDepartament(id);
        return apiCallbackTreatment(response);
    }

    async transferCalled({message, cellphoneNumberContact, idCalled, idContact, idUserCRMDestiny, idDepartamentDestiny, idServiceDigiSac})
    {
        const response = await api.whatsapp().transferCalled(message, cellphoneNumberContact, idCalled, idContact, idUserCRMDestiny, idDepartamentDestiny, idServiceDigiSac);
        return (response);
    }

    async checkingUserWithMultipleDepartaments(id) 
    {
        const response = await api.whatsapp().checkingUserWithMultipleDepartaments(id);
        return apiCallbackTreatment(response);
    }

    async getWichDepartamentsSlugsByUser(id) 
    {
        const response = await api.whatsapp().getWichDepartamentsSlugsByUser(id);
        return apiCallbackTreatment(response);
    }

    async setDepartamentsByUser(idUserCRM, slugsDepartament, idsCompanyUnits) 
    {
        const response = await api.whatsapp().setDepartamentsByUser(idUserCRM, slugsDepartament, idsCompanyUnits);
        return apiCallbackTreatment(response);
    }

    async getMessagesByChat(idCalled, idDepartament, idUserCRMOnAccess, idContact, toViewAll, amountBeforeCalleds, activeFilterByParamsURL) 
    {
        const response = await api.whatsapp().getMessagesByChat(idCalled, idDepartament, idUserCRMOnAccess, idContact, toViewAll, amountBeforeCalleds, activeFilterByParamsURL);
        return apiCallbackTreatment(response);
    }

    async sendMessageOutside(fields) 
    {
        const response = await api.whatsapp().sendMessageOutside(fields);
        return apiCallbackTreatment(response);
    }

    async getMessagesByClosedCalled(fields) 
    {
        const response = await api.whatsapp().getMessagesByClosedCalled(fields);
        return apiCallbackTreatment(response);
    }

    async openCalled(phone, idContact, idUserCRM, idDepartament, idServiceDigiSac)
    {
        const response = await api.whatsapp().openCalled(phone, idContact, idUserCRM, idDepartament, idServiceDigiSac);
        return apiCallbackTreatment(response);
    }

    async getQuickMessagesByDepartament(idDepartament)
    {
        const response = await api.whatsapp().getQuickMessagesByDepartament(idDepartament);
        return apiCallbackTreatment(response);
    }

    async getAmountNotReadCalledsByUser(id, target)
    {
        const response = await api.whatsapp().getAmountNotReadCalledsByUser(id, target);
        return apiCallbackTreatment(response);
    }

    async editMessage(id, idServiceDigiSac, message)
    {
        const response = await api.whatsapp().editMessage(id, idServiceDigiSac, message);
        return apiCallbackTreatment(response);
    }

    async setAsNotRead(idUserCRM, idCalled)
    {
        const response = await api.whatsapp().setAsNotRead(idUserCRM, idCalled);
        return apiCallbackTreatment(response);
    }

    async changeDataContact(newNameContactDigiSac, idContactDigiSac, idServiceDigiSac)
    {
        const response = await api.whatsapp().changeDataContact(newNameContactDigiSac, idContactDigiSac, idServiceDigiSac);
        return apiCallbackTreatment(response);
    }
}